import { graphql, StaticQuery } from 'gatsby'
import React, { useState, useContext } from 'react'
import Helmet from 'react-helmet'
import { themeContext } from '../lib/provider'
import Layout from '../components/layout'

import styles from '../components/globals.module.css'
import { cn } from '../lib/helpers'

const query = graphql`
    query SiteTitleQuery {
        site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
            announcementBar {
                enabled
                _rawText
                url
                openInNewTab
                backgroundColor {
                    hex
                }
                textColor {
                    hex
                }
            }
            socialLinkedin
            socialInstagram
            socialTikTok
            socialYoutube
        }
        companyInfo: sanityCompanyInfo(_id: { regex: "/(drafts.|)companyInfo/" }) {
            name
            address1
            address2
            zipCode
            city
            country
        }
        menus: sanityMenus(_id: { regex: "/(drafts.|)menus/" }) {
            hamburgerMenu {
                blank
                label
                path
                mainImage {
                    asset {
                        _id
                    }
                    alt
                }
            }
            externalHeaderMenu {
                blank
                label
                path
            }
            footerMenu {
                blank
                label
                path
                itsLabel
            }
        }
    }
`

function LayoutContainer (props) {
  const [showNav, setShowNav] = useState(false)
  const [visibleNav, setVisibleNav] = useState(true)
  // const themeCtx = useContext(themeContext)

  const handleShowNav = () => {
    setShowNav(true)
  }

  const handleHideNav = () => {
    setShowNav(false)
  }

  const handleVisibleNav = (set) => {
    setVisibleNav(set)
  }

  return (
    <StaticQuery
      query={query}
      render={data => {
        // Provide fallback data when site settings are missing
        const siteData = data.site || {
          socialLinkedin: '',
          socialInstagram: '',
          socialTikTok: '',
          socialYoutube: '',
          announcementBar: { enabled: false }
        }

        // Provide fallback data when company info is missing
        const companyInfo = data.companyInfo || {
          name: 'Company Name',
          address1: '',
          address2: '',
          zipCode: '',
          city: '',
          country: ''
        }

        // Provide fallback data when menus are missing
        const menus = data.menus || {
          hamburgerMenu: [],
          externalHeaderMenu: [],
          footerMenu: []
        }

        const announcementEnabled = !!siteData?.announcementBar?.enabled && !!siteData?.announcementBar?.text

        return (
          <>
            <Helmet
              bodyAttributes={{
                class: `${cn(((showNav || props.disableScroll) && `${styles.stick} navOpened`), (visibleNav && 'navShown'), announcementEnabled && 'announcementShown', props.palette, props.classes)}`
              }}
              htmlAttributes={{
                class: props.palette
              }}
            />
            <Layout
              {...props}
              showNav={showNav}
              announcementBar={siteData.announcementBar}
              headerNavItems={menus.hamburgerMenu}
              headerExtNavItems={menus.externalHeaderMenu}
              footerNavItems={menus.footerMenu}
              siteData={siteData}
              page={props.page}
              companyInfo={companyInfo}
              siteTitle={companyInfo.name}
              onHideNav={handleHideNav}
              onShowNav={handleShowNav}
              onVisibleNav={handleVisibleNav}
              hideContactBar={!!props.hideContactBar}
              hideAnnouncements={!!props.hideAnnouncements}
              version={props.version}
            />
          </>
        )
      }}
    />
  )
}

export default LayoutContainer
